;(function () {
  'use strict'

  angular.module('contrast.org.vulnerabilities').constant('ORG_VULN_EVENTS', {
    SERVER_TRACE_ACTIVE: 'org.server.trace.active',
    APP_TRACE_ACTIVE: 'org.app.trace.active',
    ORG_TRACE_ACTIVE: 'org.trace.active',
    LOAD_TITLE: 'org.trace.load.title'
  })
})()
